import { useMemo } from "react";
import type { SWRConfiguration, SWRResponse } from "swr";
import useApi from "../../api/useApi";
import {
    GetTrialInstitutionSupportingSiteIdentityByIdRequest,
    GetTrialInstitutionSupportingSiteIdentityByIdResponse,
    type IReturn
} from "src/api/Tmd.dtos";

const getData = (
    response?: SWRResponse<
        GetTrialInstitutionSupportingSiteIdentityByIdResponse,
        GetTrialInstitutionSupportingSiteIdentityByIdResponse
    >
) => response?.data?.trialInstitutionSupportingSiteIdentity;
const getError = (
    response?: SWRResponse<
        GetTrialInstitutionSupportingSiteIdentityByIdResponse,
        GetTrialInstitutionSupportingSiteIdentityByIdResponse
    >
) => (response?.error ?? response?.data)?.responseStatus;
const getAdditionalState = (
    response?: SWRResponse<
        GetTrialInstitutionSupportingSiteIdentityByIdResponse,
        GetTrialInstitutionSupportingSiteIdentityByIdResponse
    >
) => ({});

const useTrialInstitutionSupportingSiteIdentityById = (
    id?: number | null | undefined,
    configuration?:
        | SWRConfiguration<
              GetTrialInstitutionSupportingSiteIdentityByIdResponse,
              GetTrialInstitutionSupportingSiteIdentityByIdResponse
          >
        | null
        | undefined
) => {
    const getRequest = useMemo(() => {
        if (!id) return undefined;

        return (): IReturn<GetTrialInstitutionSupportingSiteIdentityByIdResponse> =>
            new GetTrialInstitutionSupportingSiteIdentityByIdRequest({ id });
    }, [id]);

    return useApi("get", getRequest, { getData, getError, getAdditionalState }, configuration);
};

export default useTrialInstitutionSupportingSiteIdentityById;
